<template>
    <div v-if="showModal">
        test
        <b-modal
            v-model="showModalLocal"
            title="Создание проводки 'вручную'"
            class="modal-primary"
            size="md"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <form  @submit.prevent="handleSubmit">
                <b-form-group label="Контрагент" :state="validateState('contractor')"  :invalid-feedback="veeErrors.first('contractor')">
                    <v-select
                        v-model="finance.contractor"
                        :options="getCompanies()"
                        placeholder="Выберите контрагента"
                        v-validate="{required:true,}"
                        label="title"
                        data-vv-name="contractor"
                        data-vv-as="Контрагент"
                        :state="validateState('contractor')"
                        @input="onChangeContractor()"
                    ></v-select>
                </b-form-group>

                <template v-if="finance.contractor && balance">

                    <template v-if="finance.contractor.type & CONSTANTS.COMPANY_TYPE_AGENCY">
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="дебет" label-cols="6" >
                                    <input class="form-control" v-model.number="debet" @keydown="procMinus($event, 'debet')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(debet_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="дебет по а/в" label-cols="6" >
                                    <input class="form-control" v-model.number="feedebet" @keydown="procMinus($event, 'feedebet')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(feedebet_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="поступление" label-cols="6" >
                                    <input class="form-control" v-model.number="income" @keydown="procMinus($event, 'income')">
                                </b-form-group>
                                </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(income_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="доступно" label-cols="6" >
                                    <input class="form-control" v-model.number="active" @keydown="procMinus($event, 'active')">
                                </b-form-group>
                                </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(active_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="заблокировано" label-cols="6" >
                                    <input class="form-control" v-model.number="blocked" @keydown="procMinus($event, 'blocked')">
                                </b-form-group>
                                </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(blocked_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="резерв" label-cols="6" >
                                    <input class="form-control" v-model.number="reserved" @keydown="procMinus($event, 'reserved')">
                                </b-form-group>
                                </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(reserved_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="списано" label-cols="6" >
                                    <input class="form-control" v-model.number="closed" @keydown="procMinus($event, 'closed')">
                                </b-form-group>
                                </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(closed_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="вознаграждение" label-cols="6" >
                                    <input class="form-control" v-model.number="fee" @keydown="procMinus($event, 'fee')">
                                </b-form-group>
                                </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(fee_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="штраф" label-cols="6" >
                                    <input class="form-control" v-model.number="penalty" @keydown="procMinus($event, 'penalty')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(penalty_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="кредит" label-cols="6" >
                                    <input class="form-control" v-model.number="credit" @keydown="procMinus($event, 'credit')">
                                </b-form-group>
                                </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(credit_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="кредит по а/в" label-cols="6" >
                                    <input class="form-control" v-model.number="feecredit" @keydown="procMinus($event, 'feecredit')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(feecredit_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="выплачено" label-cols="6" >
                                    <input class="form-control" v-model.number="outcome" @keydown="procMinus($event, 'outcome')">
                                </b-form-group>
                                </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(outcome_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                    </template>



                    <template v-if="finance.contractor.type & CONSTANTS.COMPANY_TYPE_HOTEL">
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="оплачено" label-cols="6" >
                                    <input class="form-control" v-model.number="outcome" @keydown="procMinus($event, 'outcome')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(outcome_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="кредит" label-cols="6" >
                                    <input class="form-control" v-model.number="credit" @keydown="procMinus($event, 'credit')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(credit_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="кредит по а/в" label-cols="6" >
                                    <input class="form-control" v-model.number="feecredit" @keydown="procMinus($event, 'feecredit')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(feecredit_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="счет в объекте" label-cols="6" >
                                    <input class="form-control" v-model.number="s_active" @keydown="procMinus($event, 's_active')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(s_active_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="зарезервировано" label-cols="6" >
                                    <input class="form-control" v-model.number="s_reserved" @keydown="procMinus($event, 's_reserved')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(s_reserved_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="услуги получены" label-cols="6" >
                                    <input class="form-control" v-model.number="s_closed" @keydown="procMinus($event, 's_closed')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(s_closed_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="вознаграждение" label-cols="6" >
                                    <input class="form-control" v-model.number="s_fee" @keydown="procMinus($event, 's_fee')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(s_fee_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="штраф" label-cols="6" >
                                    <input class="form-control" v-model.number="s_penalty" @keydown="procMinus($event, 's_penalty')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(s_penalty_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="дебет" label-cols="6" >
                                    <input class="form-control" v-model.number="debet" @keydown="procMinus($event, 'debet')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(debet_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="дебет по а/в" label-cols="6" >
                                    <input class="form-control" v-model.number="feedebet" @keydown="procMinus($event, 'feedebet')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(feedebet_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <b-form-group label="получено" label-cols="6" >
                                    <input class="form-control" v-model.number="income" @keydown="procMinus($event, 'income')">
                                </b-form-group>
                            </div>
                            <div class="col-4">
                                <b-form-group >
                                    <input class="form-control" readonly :value="formatPriceKop(income_new, false)">
                                </b-form-group>
                            </div>
                        </div>
                    </template>



                    <b-form-group label="комментарий" label-cols="4" >
                        <input class="form-control" v-model="finance.comment">
                    </b-form-group>

                    <div clss="row">
                        <div class="col-6">
                            актив {{ formatPriceKop(balance_a) }}
                        </div>
                        <div class="col-6">
                            пассив {{ formatPriceKop(balance_p) }}
                        </div>
                    </div>
                </template>

            </form>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()" :disabled="!passValidation">
                    Провести операцию
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    import vSelect from 'vue-select';

    export default {
        name: 'AddFinanceDialog',
        mixins: [functions, functions_loaders, functions_company],
        components: { vSelect },
        data: function () {
            return {
                finance: {
                    contractor:null,
                    comment: 'операция введнная вручную',
                    debet: 0,
                    feedebet: 0,
                    income: 0,
                    active: 0,
                    blocked: 0,
                    reserved: 0,
                    closed: 0,
                    fee: 0,
                    penalty: 0,
                    credit: 0,
                    feecredit: 0,
                    outcome: 0,
                    s_fee: 0,
                    s_penalty: 0,
                    s_active: 0,
                    s_reserved: 0,
                    s_closed: 0,
                },
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                //console.log('SimpleDialog: handleCancel');
                this.$emit("hide", false);
            },
            handleOk: function () {
                this.createFinance(this.finance, function (self) {
                    self.$emit("changed", false);
                }, this);
                this.$emit("hide", false);
            },
            handleSubmit: function () {
                this.createFinance(this.finance, function (self) {
                    self.$emit("changed", false);
                }, this);
                this.$emit("hide", false);
            },
            getCompanies: function() {
                return this.companies;
            },
            onChangeContractor: function() {
                if (!this.finance.contractor) {
                    this.resetBalance();
                }
                else {
                    this.resetBalance().loadBalance(this.finance.contractor.id);
                }
            },
            procMinus: function(e, o) {
                e = (e) ? e : window.event;
                var charCode = (e.which) ? e.which : e.keyCode;
                console.log('charCode=',charCode)
                if (charCode !== 189) {
                    return true;
                } else {
                    e.preventDefault();
                    this.finance[o] = - this.finance[o];
                }
            }
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            },

            balance_a: function() {
                return this.finance.active + this.finance.blocked + this.finance.reserved +this.finance.closed + this.finance.credit + this.finance.feecredit + this.finance.outcome
                    + this.finance.s_fee + this.finance.penalty;
            },

            balance_p: function() {
                return this.finance.debet + this.finance.feedebet + this.finance.income + this.finance.fee +
                    + this.finance.s_active+ this.finance.s_reserved +this.finance.s_closed + this.finance.s_penalty ;
            },

            debet: {
                get: function () { return this.finance.debet/100; },
                set: function (val) { this.finance.debet = isNaN(val)?'':Math.round(val*100); }
            },
            feedebet: {
                get: function () { return this.finance.feedebet/100; },
                set: function (val) { this.finance.feedebet = isNaN(val)?'':Math.round(val*100); }
            },
            income: {
                get: function () { return this.finance.income/100; },
                set: function (val) { this.finance.income = isNaN(val)?'':Math.round(val*100); }
            },
            active: {
                get: function () { return this.finance.active/100; },
                set: function (val) { this.finance.active = isNaN(val)?'':Math.round(val*100); }
            },
            blocked: {
                get: function () { return this.finance.blocked/100; },
                set: function (val) { this.finance.blocked = isNaN(val)?'':Math.round(val*100); }
            },
            reserved: {
                get: function () { return this.finance.reserved/100; },
                set: function (val) { this.finance.reserved = isNaN(val)?'':Math.round(val*100); }
            },
            closed: {
                get: function () { return this.finance.closed/100; },
                set: function (val) { this.finance.closed = isNaN(val)?'':Math.round(val*100); }
            },
            fee: {
                get: function () { return this.finance.fee/100; },
                set: function (val) { this.finance.fee = isNaN(val)?'':Math.round(val*100); }
            },
            penalty: {
                get: function () { return this.finance.penalty/100; },
                set: function (val) { this.finance.penalty = isNaN(val)?'':Math.round(val*100); }
            },
            credit: {
                get: function () { return this.finance.credit/100; },
                set: function (val) { this.finance.credit = isNaN(val)?'':Math.round(val*100); }
            },
            feecredit: {
                get: function () { return this.finance.feecredit/100; },
                set: function (val) { this.finance.feecredit = isNaN(val)?'':Math.round(val*100); }
            },
            outcome: {
                get: function () { return this.finance.outcome/100; },
                set: function (val) { this.finance.outcome = isNaN(val)?'':Math.round(val*100); }
            },

            s_fee: {
                get: function () { return this.finance.s_fee/100; },
                set: function (val) { this.finance.s_fee = isNaN(val)?'':Math.round(val*100); }
            },
            s_penalty: {
                get: function () { return this.finance.s_penalty/100; },
                set: function (val) { this.finance.s_penalty = isNaN(val)?'':Math.round(val*100); }
            },
            s_active: {
                get: function () { return this.finance.s_active/100; },
                set: function (val) { this.finance.s_active = isNaN(val)?'':Math.round(val*100); }
            },
            s_reserved: {
                get: function () { return this.finance.s_reserved/100; },
                set: function (val) { this.finance.s_reserved = isNaN(val)?'':Math.round(val*100); }
            },
            s_closed: {
                get: function () { return this.finance.s_closed/100; },
                set: function (val) { this.finance.s_closed = isNaN(val)?'':Math.round(val*100); }
            },

            debet_new: function(){
                return this.finance.debet + Number(this.balance.debet);
            },
            feedebet_new: function(){
                return this.finance.feedebet + Number(this.balance.feedebet);
            },
            income_new: function(){
                return this.finance.income + Number(this.balance.income);
            },
            active_new: function(){
                return this.finance.active + Number(this.balance.active);
            },
            blocked_new: function(){
                return this.finance.blocked + Number(this.balance.blocked);
            },
            reserved_new: function(){
                return this.finance.reserved + Number(this.balance.reserved);
            },
            closed_new: function(){
                return this.finance.closed + Number(this.balance.closed);
            },
            fee_new: function(){
                return this.finance.fee + Number(this.balance.fee);
            },
            penalty_new: function(){
                return this.finance.penalty + Number(this.balance.penalty);
            },
            credit_new: function(){
                return this.finance.credit + Number(this.balance.credit);
            },
            feecredit_new: function(){
                return this.finance.feecredit + Number(this.balance.feecredit);
            },
            outcome_new: function(){
                return this.finance.outcome + Number(this.balance.outcome);
            },

            s_fee_new: function(){
                return this.finance.s_fee + Number(this.balance.s_fee);
            },
            s_penalty_new: function(){
                return this.finance.s_fee + Number(this.balance.s_penalty);
            },
            s_active_new: function(){
                return this.finance.s_active + Number(this.balance.s_active);
            },
            s_reserved_new: function(){
                return this.finance.s_reserved + Number(this.balance.s_reserved);
            },
            s_closed_new: function(){
                return this.finance.s_closed + Number(this.balance.s_closed);
            },

            passValidation: function () {
                return (
                    (Number(this.finance.debet) !== 0)||
                    (Number(this.finance.feedebet) !== 0)||
                    (Number(this.finance.income) !== 0)||
                    (Number(this.finance.active) !== 0)||
                    (Number(this.finance.blocked) !== 0)||
                    (Number(this.finance.reserved) !== 0)||
                    (Number(this.finance.closed) !== 0)||
                    (Number(this.finance.fee) !== 0)||
                    (Number(this.finance.credit) !== 0)||
                    (Number(this.finance.feecredit) !== 0)||
                    (Number(this.finance.outcome) !== 0)||
                    (Number(this.finance.s_fee) !== 0)||
                    (Number(this.finance.s_active) !== 0)||
                    (Number(this.finance.s_reserved) !== 0)||
                    (Number(this.finance.s_closed) !== 0)||
                    (Number(this.finance.penalty) !== 0)||
                    (Number(this.finance.s_penalty) !== 0)) &&
                    (this.balance_a === this.balance_p);
            }
        },
        created: function() {
            this.loadCompanies();
        },
        mounted: function() {
            //console.log('SimpleDialog: mounted');
        },
        updated: function() {
            //console.log('SimpleDialog: updated');
        },
    }
</script>
